export interface SessionState {
  isLogged: boolean;
  AccessToken?: string | '';
}

export type SessionActionType = SessionState;

export type RepAutenticationState = SessionState;

export const initialRepAuthState: RepAutenticationState = {
  isLogged: false,
  AccessToken: '',
};
